
import { SMQuestionnaire } from "@/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TAnswerBlock } from "../TAnswerBlocks";

@Component
export default class AnswerBlockSwitch extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly answerBlockData!: TAnswerBlock;
  @Prop({ type: Number, default: () => 0 }) readonly index: number | undefined;
  @Prop({ type: Number, default: () => 0 }) readonly loopIndex: number | undefined;

  @Watch("input")
  updateAnswer(value: boolean) {
    if (this.index === null) return;

    SMQuestionnaire.updateAnswer({
      index: this.index,
      value: String(value),
      required: this.answerBlockData.is_required,
      answer_block_id: this.answerBlockData.ID,
      answer_block_alias: this.answerBlockData.answer_block_alias,
      loop_index: this.loopIndex,
      condition: this.answerBlockData.condition,
    });
  }

  input = false;

  created() {
    const answer = SMQuestionnaire.answers.find(
      (answer) =>
        answer.answer_block_id === this.answerBlockData.ID && this.loopIndex === answer.loop_index
    );

    if (this.index != null && answer) {
      this.input = answer.value === "true";
    }

    this.updateAnswer(this.input);
  }
}
